module.exports = __webpack_public_path__ + "static/media/lux.07ea4bef.png";